import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { BannerContents } from "../../../components/shared/layout";
import { Button } from "../../../components/shared/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { LINKS } from "@constants";
import imagensVida from "@asserts/images/vida";
import imagensHome from "@asserts/images/home";
import imagensPrestamista from "@asserts/images/prestamista";
import imagensPrevidencia from "@asserts/images/previdencia/index";
import GuiaButton from "../../../components/shared/actions/GuiaButton";
import "../../../components/shared/actions/GuiaButton.css";
import "./BannerHome.css";

const BannerItem = ({ image, title, text, button, icon, position }) => (
  <BannerContents.Banner
    backgroundImage={image}
    className="text-white"
    {...(position === "right" ? { right: true } : { left: true })}
  >
    <Row>
      <Col xs={12} md={12} className="ps-md-7 d-flex align-items-stretch">
        {icon && (
          <FontAwesomeIcon
            className="d-none d-md-inline-block cvp-icon-banner"
            icon={icon}
          />
        )}
        <h4 className="d-md-inline-block">{title}</h4>
      </Col>
      <Col xs={12} md={12} className="ps-md-7">
        <p className="text-body-md">{text}</p>
        {button && (
          <Button className="mt-3" blank secondary href={button.href}>
            {button.text}
          </Button>
        )}
      </Col>
    </Row>
  </BannerContents.Banner>
);

const GenericBanner = ({
  image,
  className,
  title,
  text,
  button,
  titleClassName,
  textClassName
}) => (
  <BannerContents.Banner backgroundImage={image} className={className} left>
    <Row>
      <Col xs={12} md={12} className="ps-md-7 d-flex align-items-stretch">
        <h4 className={`d-md-inline-block ${titleClassName}`}>{title}</h4>
      </Col>
      <Col xs={12} md={12} className="ps-md-7">
        <p className={`text-body-md mt-0 mt-md-2 ${textClassName}`}>{text}</p>
        {button && (
          <Button
            className={`mt-2 ${button.className}`}
            blank
            secondary
            href={button.href}
          >
            {button.text}
          </Button>
        )}
      </Col>
    </Row>
  </BannerContents.Banner>
);

export const BannerHome = (props) => {
  const allBanners = [
    {
      image: imagensVida.bannerSeuFuturo,
      title: (
        <div style={{ marginTop: "50px" }} className="banner-seu-futuro-title">
          Seu futuro protegido começa agora!
        </div>
      ),
      text: (
        <div style={{ marginTop: "5px" }}>
          <p className="text-body-md mt-0 mt-md-2 banner-seu-futuro-text">
            Contrate o Seguro Amparo e tenha uma vida
            <br />
            mais tranquila para você e para quem ama.
          </p>
          <p className="banner-seu-futuro-text">
            Planos a partir de <b>R$ 40/ano.</b>
          </p>
        </div>
      ),
      button: { text: "Saiba mais", href: LINKS.amparoConfortoBanner },
      position: "left"
    },
    {
      image: imagensVida.bannerVida,
      title: "Seguro de vida",
      text: "Clientes CAIXA agora podem comprar o Seguro de Vida 100% online.",
      button: { text: "Compre agora", href: LINKS.autoCompraVida },
      position: "left"
    },
    {
      image: imagensPrestamista.bannerPrestamista,
      title: "Seguro Dívida Zero",
      text:
        "Garanta o pagamento do seu empréstimo junto à CAIXA em caso de morte ou invalidez total",
      button: { text: "Já sou cliente", href: LINKS.areaLogada },
      icon: FaFileInvoiceDollar,
      position: "right"
    },
    {
      image: imagensPrevidencia.bannerPrevidencia,
      title: "Previdência",
      text:
        "Uma decisão para se orgulhar lá na frente. Faça agora sem precisar sair de casa",
      button: { text: "Comprar agora", href: LINKS.autoCompraPrevidencia },
      icon: faPiggyBank,
      position: "right"
    }
  ];

  const banners = allBanners;

  return (
    <BannerContents {...props}>
      <BannerContents.Banner
        backgroundImage={imagensHome.bannerDezAnosSeguridade}
        group={["voce", "coberturas-assistencias", "resultado-sorteios"]}
        className="text-white bg-dez-anos-seguridade"
      >
        <h3 className="d-md-inline-block banner-dez-anos-seguridade">
          Nos 10 anos da Caixa Seguridade
        </h3>
        <p className="text-body-md banner-dez-anos-seguridade">
          Benefícios para você:
        </p>
        <p className="text-body-md banner-dez-anos-seguridade">
          Traga sua Previdência e Ganhe CASHBACK de até R$10 Mil.
        </p>
        <p className="text-body-md banner-dez-anos-seguridade">
          Contrate o Seguro BEM-ESTAR e Concorra a Sorteios de R$200 Mil.
        </p>
        <div className="botao-dez-anos-seguridade" />
        <Button
          className="text-center cvp-action-comprar"
          blankd
          secondary
          href={LINKS.regulamentoGeral6812}
          style={{ fontWeight: "bold" }}
        >
          Acesse o regulamento
        </Button>
      </BannerContents.Banner>
      <BannerContents.Banner
        className="text-white"
        backgroundImage={imagensPrevidencia.bannerNovaRegraIOF}
        right
      >
        <div className="banner-Bloco">
          <div className="banner-Bloco-left">
            <img
              src={imagensPrevidencia.alertaBannerNovaRegraIOF}
              alt="Alerta"
            />
            <span className="banner-nova-regra-atencao">ATENÇÃO!</span>
          </div>

          <div className="banner-Bloco-right">
            <h4 className="banner-nova-regra-title">
              Novas regras para <br />
              aportes em planos VGBL
            </h4>
            <p className="banner-nova-regra-text">
              A partir de 11/06/2025, contribuições acima de R$ 300 mil em
              planos VGBL, estarão sujeitas à cobrança de 5% de IOF.
            </p>
            <div className="banner-nova-regra-button">
              <Button
                blank
                className="mt-2"
                secondary
                href={LINKS.novaRegraIOF}
              >
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </BannerContents.Banner>
      {banners.map((banner) => (
        <BannerItem key={banner.title} {...banner} />
      ))}
      <GenericBanner
        image={imagensPrevidencia.bannerAssistenciaProtecao}
        text={
          <>
            <div className="margin-top-ajustada">
              <h4 style={{ color: "#F39200", fontSize: "1.6rem" }}>
                ASSISTÊNCIAS QUE VÃO
                <br /> ALÉM DA PROTEÇÃO
              </h4>
              <p>
                Com os nossos Seguros de Vida e planos de Previdência, você
                conta com assistências exclusivas que facilitam seu dia a dia e
                garantem tranquilidade nos momentos em que mais precisa.
              </p>
              <h4>Conheça os serviços disponíveis.</h4>
            </div>
            <div style={{ marginTop: "32px" }}>
              <GuiaButton href={LINKS.guiaAssistencias2025}>
                BAIXE O GUIA
              </GuiaButton>
            </div>
          </>
        }
        textClassName="text-assistencias"
      />
    </BannerContents>
  );
};

BannerHome.defaultProps = { images: {} };

BannerHome.propTypes = {
  images: PropTypes.objectOf(Object)
};

export default BannerHome;
